import React, { useEffect } from "react";
import "./AssistedLiving.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import assistedImg from "../../Asset/Images/Assisted_Living.jpeg";

const AssistedLiving = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  // Keys for the 8 support cards
  const supportPoints = [
    "assisted.point1",
    "assisted.point2",
    "assisted.point3",
    "assisted.point4",
    "assisted.point5",
    "assisted.point6",
    "assisted.point7",
    "assisted.point8"
  ];

  return (
    <div className="assisted_page">
      {/* HERO SECTION */}
      <section className="assisted_hero">
        <div className="assisted_card_container">
          {/* LEFT CONTENT */}
          <div className="assisted_content" data-aos="fade-right">
            <span className="service_tag">{t('assisted.service_tag')}</span>
            <h1>
              {t('assisted.title_start')} <span>{t('assisted.title_end')}</span>
            </h1>
            <p>{t('assisted.hero_desc')}</p>
          </div>

          {/* RIGHT IMAGE */}
          <div className="assisted_image" data-aos="fade-left">
            <img src={assistedImg} alt={t('assisted.title_start') + " " + t('assisted.title_end')} />
          </div>
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="assisted_details">
        <h2 data-aos="fade-up">{t('assisted.details_title')}</h2>
        <div className="assisted_grid">
          {supportPoints.map((key, index) => (
            <div className="assisted_card" key={index} data-aos="zoom-in">
              {t(key)}
            </div>
          ))}
        </div>
      </section>

      {/* CALL TO ACTION */}
      <section className="assisted_cta" data-aos="fade-up">
        <h2>{t('assisted.cta_title')}</h2>
        <p>{t('assisted.cta_desc')}</p>
        <NavLink to="/Contactus">
          <button className="assisted_cta_btn">
            {t('assisted.cta_btn')}
          </button>
        </NavLink>
      </section>
    </div>
  );
};

export default AssistedLiving;